import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import InputField from '../../../common/InputField';

import AddButton from './buttonmanagement/AddButton'
import RemoveButton from './buttonmanagement/RemoveButton'

const styles = (theme) => {
    return {
        dialogText: {
            paddingBottom: 24,
        },
        dialogControlGroup: {
            marginRight: 24,
            marginLeft: 24,
            marginBottom: 24,
        },
        dialogControl: {
            marginLeft: 16,
            marginRight: 0,
        },
        dialogInviteGroup: {
            display: '-webkit-flex',
        },
    };
}

class InviteForm extends Component {
    constructor(props) {
        super(props);

        this._refMap = {
            username: React.createRef(),
        };

        this.state = {
            email: "",
            timestamp: 0,
        };

        this._emailBasket = [{ key: Date.now(), email: "", refObject: React.createRef() }];
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.props.open !== nextProps.open ||
            this.state.timestamp !== nextState.timestamp)
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div>
                <Dialog
                    fullWidth={true}
                    disableBackdropClick={false}
                    disableEscapeKeyDown={false}
                    open={this.props.open}
                    onBackdropClick={this._handleCancel}
                    onEscapeKeyDown={this._handleCancel}
                >
                    <form onSubmit={this._handleOk}>
                        <DialogTitle>
                            Invite New Member
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText className={classes.text}>
                                Please enter a list of the new members email.
                                An invitation email will be sent containing
                                a link to join your organization. (Maximum 5 per batch).
                            </DialogContentText>
                            {this._emailBasket.map(this._renderEmailInput)}
                        </DialogContent>
                        <DialogActions className={classes.dialogControlGroup}>
                            <Button
                                className={classes.dialogControl}
                                color='secondary'
                                onClick={this._handleCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                className={classes.dialogControl}
                                color='secondary'
                                variant='contained'
                                type='submit'
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </div>
        );
    }

    _renderEmailInput = (userinput, idx) => {
        const {classes} = this.props;

        return (
            <div
                key={userinput.key}
                className={classes.dialogInviteGroup}
            >
                <InputField
                    innerRef={userinput.refObject}
                    id='username'
                    label='Email'
                    type='email'
                    autoFocus={true}
                    onValidate={this._validateTextField}
                    value={userinput.email}
                />
                {this._addAndRemoveButtons(idx)}
            </div>
        )
    }

    _addAndRemoveButtons = (idx) => {
        if (idx === (this._emailBasket.length - 1)) {
            if (this._emailBasket.length >= 5) {
                return (
                    <RemoveButton
                        info={idx}
                        onClick={this._handleRemoveEmail}
                    />
                )
            } else {
                return (
                    <AddButton
                        info={idx}
                        onClick={this._handleAddEmail}
                    />
                )
            }
        } else {
            return (
                <RemoveButton
                    info={idx}
                    onClick={this._handleRemoveEmail}
                />
            )
        }
    }

    _handleAddEmail = (idx) => {
        this._emailBasket.push({
            key: Date.now(),
            email: "",
            refObject: React.createRef(),
        });

        this.setState({
            timestamp: Date.now(),
        });
    }

    _handleRemoveEmail = (idx) => {
        this._emailBasket.splice(idx, 1);

        this.setState({
            timestamp: Date.now(),
        });
    }

    _handleOk = (event) => {
        event.preventDefault();

        const listOfEmail = this._emailBasket
        const tempStack = []

        var needReset = false;

        for (const emailcheck of listOfEmail) {
            if (emailcheck.refObject.current._value === "") {
                continue;
            } else {
                needReset = true;
                tempStack.push(emailcheck.refObject.current._value)
            }
        }
        if (this.props.onOk) {
            this.props.onOk(tempStack);
        }
        if (needReset) {
            this._resetState();
        }
    }

    _handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }

        this._resetState();
    }

    _validateTextField = (id, value) => {
        return (!value) ? 'Required' : '';
    }

    _resetState = () => {
        this.setState({
            email: "",
            timestamp: Date.now(),
        });

        this._emailBasket = [{ key: Date.now(), email: "", refObject: React.createRef() }];
    }
}

InviteForm.propTypes = {
    open: PropTypes.bool.isRequired,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
}

export default withStyles(styles)(InviteForm);
